import React from 'react';

export const TITLE_ABOUT = [
  {
    textSize: '3.375rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>ABOUT</span>,
  },
];

export const ABOUT_NAME = [
  {
    textSize: '4rem',
    fontWeight: '600',
    marginBottom: '0px',
    lineHeight: '60px',
    textType: 'h2',
    textMobile: '2.125rem',
    renderContent: () => <span>JONATHAN BOUZALI</span>,
  },
];

export const ABOUT_CHARGE = [
  {
    textSize: '2.25rem',
    fontWeight: '900',
    lineHeight: '60px',
    marginBottom: '1.5rem',
    renderContent: () => (
      <span>
        <em>PRODUCER</em>
      </span>
    ),
  },
];

export const ABOUT_DESCRIPTION = [
  {
    textSize: '1.25rem',
    fontWeight: '400',
    marginBottom: '0px',
    lineHeight: '25px',
    textMobile: '0.875rem',
    renderContent: () => (
      <span>
        Jonathan Bouzali is a producer with over two decades of experience
        across film, television, and advertising, specializing in managing
        complex projects for global platforms and studios. He has led
        productions for Netflix, Paramount, Disney, Gaumont, and Apple TV+,
        building a track record defined by operational precision and creative
        control. His credits include titles such as Souvenir, the investigative
        thriller Tijuana, and a range of projects spanning drama, suspense,
        horror, and comedy—showcasing a rare narrative versatility within the
        industry.
        <br />
        <br />
        He is a member of EAVE’s PUENTES 2024 program, an international network
        dedicated to the development of co-productions between Europe and Latin
        America. In parallel, he has experience within the music industry as a
        founding member and voting member of the Latin Grammys (LARAS),
        expanding his understanding of the creative ecosystem beyond the
        audiovisual space.
        <br />
        <br />
        Jonathan has built high-level strategic partnerships through
        international productions such as 37 KMS and The Bachelor Japan (Amazon
        Studios), positioning his company—KUTER—within the circuit of production
        houses with a proven ability to deliver stories that are universal,
        culturally relevant, and technically impeccable.
        <br />
        <br />
        All work carried out in his capacity as a producer over the years forms
        part of his professional experience and has been developed either
        independently or through the different stages of consolidation of his
        own production company.
        <br />
        <br />
        Today, Jonathan Bouzali focuses his creative and operational activity
        exclusively under the KUTER Films label, from where he continues to
        drive, develop, and present the projects he leads.
      </span>
    ),
  },
];
